export const styles = {
  container: {
    padding: '10px 20px',
    minHeight: '60vh',
    borderRadius: 8,
  },
  searchContainer: {
    width: '100%',
  },
  citySelectContainer: {
    border: '1px solid #E2E2FC',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 14,
    marginBottom: 24,
  },
  roleSelectorTitle: {
    fontSize: 16,
    color: '#798498',
    marginBottom: 5,
    fontFamily: "'Proxima Nova', sans-serif",
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    fontFamily: "'Proxima Nova', sans-serif",
    textAlign: 'center',
    marginTop: -60,
  },
  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    width: 100,
    position: 'absolute',
    bottom: 0,
    marginBottom: 20,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 30,
  },

  chipContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 26,
  },
  customSelectContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  closeIcon: {
    width: 10,
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: -48,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chipContainerStyle: {
    width: '100%',
    marginLeft: -20,
    overflowY: 'scroll',
    maxHeight: 280,
  },
}
